import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const PAGE_SIZES = [10, 25, 50];

// Shared pagination bar: Prev / Next + "x / y" indicator + 10/25/50 per-page selector.
// Hidden entirely when there's nothing to paginate (total fits the smallest page).
export function PaginationControls({ page, total, pageSize, onPageChange, onPageSizeChange, pageSizeOptions = PAGE_SIZES, testidPrefix = "pagination", className = "" }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const sizes = pageSizeOptions.length ? pageSizeOptions : PAGE_SIZES;
  if (total <= Math.min(pageSize, ...sizes)) return null;
  return (
    <div className={`mt-6 flex flex-wrap items-center justify-center gap-3 ${className}`}>
      <Button
        data-testid={`${testidPrefix}-prev-page`}
        variant="outline"
        size="sm"
        disabled={page === 0}
        onClick={() => onPageChange(Math.max(0, page - 1))}
        className="border-white/15 text-white"
      >
        <ChevronLeft className="h-4 w-4 mr-1" /> Prev
      </Button>
      <div className="font-mono text-xs text-white/50" data-testid={`${testidPrefix}-page-indicator`}>{page + 1} / {totalPages}</div>
      <Button
        data-testid={`${testidPrefix}-next-page`}
        variant="outline"
        size="sm"
        disabled={page + 1 >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className="border-white/15 text-white"
      >
        Next <ChevronRight className="h-4 w-4 ml-1" />
      </Button>
      <div className="flex items-center gap-2 sm:ml-3">
        <span data-testid={`${testidPrefix}-page-size-label`} className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">Per page</span>
        <Select value={String(pageSize)} onValueChange={(v) => onPageSizeChange(Number(v))}>
          <SelectTrigger data-testid={`${testidPrefix}-page-size`} aria-label="Items per page" className="h-8 w-[72px] bg-[hsl(220_18%_12%)] border-white/10 font-mono text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-[hsl(220_18%_10%)] border-white/10">
            {sizes.map((s) => (
              <SelectItem key={s} value={String(s)} className="font-mono text-xs" data-testid={`${testidPrefix}-page-size-${s}`}>{s}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
